import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export const debugObservable =
  <T>(name: string = 'observable', log: (message: string, payload?: unknown) => void = console.log) =>
  (obs: Observable<T>): Observable<T> =>
    obs.pipe(
      tap({
        next: val => log(`[${name}] next`, val),
        error: err => log(`[${name}] error`, err),
        complete: () => log(`[${name}] complete`)
      })
    );
